import './index.scss';

import React from 'react';
import modifiers from "../../../util/components";

class ButtonGroup extends React.Component
{
  static defaultProps = {
    children: [],
    modifiers: null
  };

  render() {

    return (
      <div className={"button-group"+modifiers('button-group', this.props.modifiers)}>
        {this.props.children.length > 1 ? (

          this.props.children.map((child, index)  => {
            return (
              <div key={index} className="button-group__item">
                {child}
              </div>
            );
          })
          ) : (
            <div className="button-group__item">
              {this.props.children}
            </div>
          )
        }
      </div>
    );
  }
}

export default ButtonGroup;